import { I18nData, type DeepPartial } from 'app/src/model'
import { membershipApi } from 'app/src/services/welfareportal'
import libI18n from 'i18next'
import { merge } from 'lodash'
import { HttpClientType } from '../hooks'

export async function fetchI18nResources(templateId: string, httpClient: HttpClientType): Promise<I18nData | null> {
  const buildInfo = window.__RUNTIME_CONFIG__
  const buildId = buildInfo?.buildId || 'unknown'
  const buildTimestamp = buildInfo?.buildTimestamp || Date.now().toString()

  try {
    // Fetch base i18n resources
    const baseResp = await httpClient.executeJson<I18nData>({
      input: `./api/v1/i18n?version=${buildId}_${buildTimestamp}`,
    })

    // Fetch template-specific i18n resources
    const templateI18nResp = await httpClient.executeJson<DeepPartial<I18nData>>({
      input: `./api/v1/${templateId}/i18n?version=${buildId}_${buildTimestamp}`,
    })

    let mergedI18n: I18nData | null = baseResp?.jsonResponse

    if (!templateI18nResp.fetchError && templateI18nResp.httpResponse?.status === 200) {
      mergedI18n = merge(mergedI18n, templateI18nResp?.jsonResponse)
    }

    return mergedI18n
  } catch (error) {
    console.error('[i18nutils] Error fetching i18n resources:', error)
    return null
  }
}

/**
 * Aggiorna le risorse i18n runtime senza reinizializzare i18next
 */
export async function updateI18nResources(
  frontendConfiguration: membershipApi.FrontendConfiguration | undefined,
  httpClient: HttpClientType,
) {
  if (!frontendConfiguration?.templateId) {
    console.warn('[i18nutils] No templateId provided, skipping i18n update')
    return
  }

  const mergedI18n = await fetchI18nResources(frontendConfiguration.templateId, httpClient)

  // Update i18next resources
  if (mergedI18n?.resources) {
    Object.keys(mergedI18n.resources).forEach((lng) => {
      const languageResources = mergedI18n!.resources[lng]
      if (languageResources) {
        Object.keys(languageResources).forEach((ns) => {
          libI18n.addResourceBundle(lng, ns, languageResources[ns as keyof typeof languageResources], true, true)
        })
      }
    })
  }
}
